import axiosInstance from './axiosInstance';

export const login = (data) => axiosInstance.post('/auth/login', data);
export const register = (data) => axiosInstance.post('/auth/register', data);
export const getMe = () => axiosInstance.get('/auth/me');
export const updateProfile   = (data) => axiosInstance.put('/auth/profile', data);
export const changePassword  = (data) => axiosInstance.put('/auth/change-password', data);
export const forgotPassword  = (data) => axiosInstance.post('/auth/forgot-password', data);
export const resetPassword   = (data) => axiosInstance.post('/auth/reset-password', data);
